import type { MenuLink } from "core-fe-lib/components-shadcn/types/menu-link";
import { Role } from "core-fe-lib/openapi/core/models/Role";

export function getCreditLinks(t: any): MenuLink[] {
  return [
    {
      title: t("credit.title"),
      caption: t("credit.caption"),
      icon: "credit_card",
      hasExpansion: true,
      requiredPrivilege: Role.ADMIN,
      linkType: "ADMIN",
      items: [
        {
          title: t("credit.buy.menuTitle"),
          icon: "shopping_cart",
          link: "/credit/buy",
        },
        {
          title: t("credit.myTopups.menuTitle"),
          icon: "history",
          link: "/credit/me/topups",
        },
        {
          title: t("credit.balances.home.title"),
          icon: "account_balance_wallet",
          link: "/credit/balances",
          requiredPrivilege: Role.ADMIN,
          linkType: "ADMIN",
        },
        {
          title: t("credit.adminTopups.menuTitle"),
          icon: "payments",
          link: "/credit/topups",
          requiredPrivilege: Role.ADMIN,
          linkType: "ADMIN",
        },
        {
          title: t("credit.transactions.title"),
          icon: "receipt_long",
          link: "/credit/transactions",
          requiredPrivilege: Role.ADMIN,
          linkType: "ADMIN",
        },
        {
          title: t("credit.plans.menuTitle"),
          icon: "workspace_premium",
          link: "/credit/plans",
          requiredPrivilege: Role.SUPER_ADMIN,
          linkType: "ADMIN",
        },
      ],
    },
  ];
}
